namespace TabAurous.OMS {
    export interface TaxRateHistoryRow {
        Date?: string;
        TaxId?: number;
        Rate?: number;
    }

    export namespace TaxRateHistoryRow {
        export const idProperty = 'TaxId';
        export const localTextPrefix = 'OMS.TaxRateHistory';
        export const lookupKey = 'OMS.TaxRateHistory';

        export function getLookup(): Q.Lookup<TaxRateHistoryRow> {
            return Q.getLookup<TaxRateHistoryRow>('OMS.TaxRateHistory');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Date = "Date",
            TaxId = "TaxId",
            Rate = "Rate"
        }
    }
}
